module.exports = __webpack_public_path__ + "img/29.0ec22a95.png";